export default __webpack_public_path__ + "static/media/cif-ni.f7d96a82.svg";